import { Divider } from "antd";
import { Link, useLocation } from "react-router-dom";
import { useContext } from "react";
import { EditOutlined } from "@ant-design/icons";
import { settingsPersonalPath, userPassportPath } from "../../routes/routes";
import {
  LangContext,
  UiTextsContext,
  UserDataContext,
} from "../../contexts/Contexts";
import "./UserSider.css";

export const UserSider = () => {
  const { userData } = useContext(UserDataContext);
  const { texts } = useContext(UiTextsContext);
  const { lang } = useContext(LangContext);
  const location = useLocation();
  const returnTo = `${location.pathname}${location.search}`;
  const currentLang = String(lang || userData?.idioma || "en").toLowerCase();
  const passportImageSrc =
    currentLang === "es"
      ? "/img/interfaz/Pasaporte.png"
      : "/img/interfaz/Group 1000002982-3.png";

  return (
    <>
      <div className="user-sider-contain">
        <div className="user-sider-card">
          {/* <Link className="bio-container" to={settingsPersonalPath}> */}

          <div className="bio-edit">
            <div className="bio-container">
              <div className="edit-text-bio">
                <div className="bio-text">
                  <span>{userData?.bio || texts?.AL0022}</span>
                </div>
                <Link
                  className="edit-icon-bio"
                  to={settingsPersonalPath}
                  state={{ returnTo }}
                >
                  <EditOutlined />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="user-sider-card row-userSiderPassport">
          <Link to={userPassportPath}>
            <div className="passport-sider-container">
              <img
                src={passportImageSrc}
                alt="passport"
                className="passport-img"
              />
            </div>
          </Link>
        </div>
      </div>

     
    </>
  );
};
